import { createGlobalStyle } from 'styled-components';
import colors from './colors';

export default createGlobalStyle`
  * {
    padding: 0;
    outline: 0;
    box-sizing: border-box;
    margin: 0;
  }

  body{
    height: 100%;
    margin: 0;
    font-family: 'Montserrat', sans-serif;
    background-color: #E5E5E5;
  }

  html,body,#root{
    height: 100%;
  }
  
  h1, h3, h4, h5, h6, small, a, p, span, small, strong {
    letter-spacing: 0.03em;
    color: #C4C4C4;
    font-weight: normal;
  }

  a {
    color: #25BBAB;
  }

  button {
    cursor: pointer;
  }

  button[disabled] {
    background: ${colors.grayLight};
    border: 1px solid ${colors.grayLight};
    color: ${colors.white};
  }

  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type=number] {
    -moz-appearance: textfield;
  }

  input {
    letter-spacing: 0.03em !important;
    font-family: 'Montserrat', sans-serif;
  }
`;
